import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientDetailsActions, IThunkGetMedications } from '../types';

const onGetMedications: IThunkGetMedications = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload) => {
    const { clinicId, teamId, clientId } = payload;

    const medications = await api.clientDetails
      .getClientMedicationList(clinicId, teamId, clientId)
      .then(r => r.data);

    setClientDetails({ medications });
  },
);

export default onGetMedications;
